import { fetchBasicUrlPostJson } from '@/script/common';

export default {
    getData: (page, itemsPerPage, filter, signal) => {
        let parameters = {
            page: page,
            pageSize: itemsPerPage,
            ...filter
        };
        return fetchBasicUrlPostJson('/Brunva/GetGridsData', {
            asGridData: true,
            data: parameters,
            signal
        });
    }
};
